<template>
<a-spin :spinning="spinning" tip="Loading...">
  <div class="card mb-3">
    <div class="row no-gutters">
      <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-7">
              <div class="row">
                <div class="col-md-7">
                  <base-input alternative="" label="Date Range"><br>
                    <a-range-picker v-model="dateRange"
                                    format="MM-DD-YYYY"
                                    :placeholder="['Start Date', 'End Date']"
                                    style="width:100%"/>
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="siteType == 'ho'">
                  <div class="col-md-7">
                      <base-input label="Location">
                          <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                      </base-input>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-7">
                  <base-input label="Choose Site">
                    <a-select mode="multiple" showSearch
                              placeholder="All Sites"
                              optionFilterProp="children"
                              style="width: 100%"
                              v-model="selectedSite"
                              :filterOption="filterOption"
                              :disabled="siteType != 'ho'">
                      <a-select-option v-for="option in sites"
                                        :key="option.id"
                                        :value="option.id">
                        {{ option.name }}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-md-4 align-self-center">
                <div v-if="reportDescription != ''" class="card">
                    <div class="card-body">
                        <div class="card-text">
                            {{ reportDescription }}
                        </div>
                    </div>
                </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-12">
              <br>
              <button class="btn btn-sm btn-default float-right"
                      style="border-radius: 24px; border:0px; width: 20%;"
                      @click.prevent="generatePDF">
                Generate Report in PDF
              </button> &nbsp; &nbsp;

              <button v-if="exportJsonData.length < 1"
                      class="btn btn-sm btn-default float-right"
                      style="border-radius: 24px; border:0px; width: 20%;"
                      @click.prevent="generateFile">
                Generate Report
              </button> &nbsp; &nbsp;

              <vue-json-to-csv v-if="exportJsonData.length > 0"
                                :labels="csvHeaders"
                                :json-data="exportCSV()"
                                @success="clearExportJsonData()"
                                :csv-title="`${exportFileName}.csv`">
                <button id='clickCsvExport'
                        class="btn btn-sm btn-success float-right"
                        style="border-radius: 24px; border:0px; width: 20%;">
                  Download CSV
                </button> &nbsp; &nbsp;
              </vue-json-to-csv>

              <download-excel v-if="exportJsonData.length > 0"
                              class="float-right"
                              style=" width: 20%;"
                              worksheet="Physical Count - Variance Report"
                              :name="`${exportFileName}.xls`"
                              :fetch="exportExcel"
                              :fields="excelHeaders">
                <button class="btn btn-sm btn-success"
                        style="border-radius: 24px; border:0px; width: 100%;">
                  Download excel
                </button> &nbsp; &nbsp;
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</a-spin>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import VueJsonToCsv from 'vue-json-to-csv';
import { mapState } from 'vuex'
import { getReportDescription } from '../../utilities';
const documentName = "Physical_Count_Variance_Report";

export default {
  data() {
    return {
      spinning: false,
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      siteType: 'ho',
      selectedSite: [],
      sites: [],
      exportFileName: `${documentName}-${moment().format('YYYYMMDDHHmmss')}`,
      exportJsonData: [],
      excelHeaders: {
        "Document No": "documentNo",
        "Posted At": "postedAt",
        "Line No.": "lineNo",
        "Product Code": "productCode",
        "Stock No.": "stockNo",
        "Barcode": "barcode",
        "Reference Code": "refCode",
        "Description": "description",
        "Actual Quantity": "actualQuantity",
        "On-Hand Quantity": "onHandQuantity",
        "Variance": "variance",
      },
      excelJsonData: [],
      csvHeaders: {
        documentNo: { title: "Document No." },
        postedAt: { title: "Posted At" },
        lineNo: { title: "Line No." },
        productCode: { title: "Product Code" },
        stockNo: { title: "Stock No." },
        barcode: { title: "Barcode" },
        refCode: { title: "Reference Code" },
        description: { title: "Description" },
        actualQuantity: { title: "Actual Quantity" },
        onHandQuantity: { title: "On-Hand Quantity" },
        variance: { title: "Variance" },
      },
      csvJsonData: [],
      reportDescription: '',
      inputLocation:[],
      locationOptions: [],
    }
  },
  computed: {
    ...mapState(['endPoint', 'categoriesOptions','currentProfile']),
  },
  components:{
    VueJsonToCsv
  },
  beforeMount: async function() {
    // Check if user has permission for Basic Inventory Reports (R-002) Physical Count - Variance Report (BI-008)
    const userActiveModulesURL = `${this.endPoint}system_module_categories/user_enabled_modules?module_codes=BI-008&category_codes=R-002`;
    const userActiveModules = await HTTPRequest.getRequest(userActiveModulesURL, null, null);
    if (userActiveModules.enabled_modules.length == 0) {
      this.$router.push('dashboard');
      return;
    }
  },
  mounted: async function () {
    const userId = secureStorage.getItem("userId")
    const sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
    this.sites = sites;
    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

    const siteId = secureStorage.getItem("defaultSiteId");
    this.selectedSite = [siteId];
    this.reportDescription = await getReportDescription(this.currentProfile)
    // let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
    // if(site != undefined) { this.siteType = site.site_type; }
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    clearExportJsonData() {
      this.exportJsonData = [];
    },
    computeVariance(onHandQuantity, actualQuantity) {
      const variance =  parseFloat(onHandQuantity || "0") - parseFloat(actualQuantity || "0");
      return `${variance}`
    },
    async onLocationChange(){
      if (!this.inputLocation[this.inputLocation.length - 1]){
          var user_id = secureStorage.getItem("userId")
          this.sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + user_id, null);
          this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
          let site_id = secureStorage.getItem("defaultSiteId");
          this.selectedSite = [site_id]
        }else {
          this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
          this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
          this.selectedSite = this.sites.map( s => s.id);
      }
    },

    getData: async function () {
      this.spinning= true;
      // Initialize url and params
      let url = `${this.endPoint}basic_inventory_reports/physical_count_variance_report`;
      let from = this.dateRange[0].format('YYYY-MM-DD');
      let to = this.dateRange[1].format('YYYY-MM-DD');
      let params = `?site_id=${this.selectedSite.toString()}&from=${from}&to=${to}`;
      url = `${url}${params}`;

      // Request for Physical Count data
      const request = await HTTPRequest.getRequest(url, null, null);
      let errorMsg = "";

      if (!request.reports) {
        errorMsg = request.error;
      } else if (request.reports.length == 0) {
        errorMsg = "No Data."
      }

      if (errorMsg.length > 0) {
        // Prompt an error if no report found
        this.$notification['error']({ message: 'Export Error', description: errorMsg });
        this.spinning= false;
        return [];
      }
      this.spinning= false;
      return request.reports;
    },
    generatePDF: async function() {
      const reports = await this.getData();
      if (reports.length == 0) { return; }

      const printedBy = secureStorage.getItem("email") || "";

      let headers = [
        [{ content: "Physical Count - Variance Report", colSpan: 9, styles: {halign: 'center'} }],
        [
          { content: 'Line No.', styles: { halign: 'center' } },
          { content: 'Product Code', styles: { halign: 'center' } },
          { content: 'Stock No.', styles: { halign: 'center' } },
          { content: 'Barcode', styles: { halign: 'center' } },
          { content: 'Reference Code', styles: { halign: 'center' } },
          { content: 'Description', styles: { halign: 'center' } },
          { content: 'Actual Quantity', styles: { halign: 'center' } },
          { content: 'On-Hand Quantity', styles: { halign: 'center' } },
          { content: 'Variance', styles: { halign: 'center' } },
        ]
      ];

      let columnStyles = {
        0: {cellWidth: 10, halign: 'center'},
        1: {cellWidth: 35, halign: 'left'},
        2: {cellWidth: 35, halign: 'left'},
        3: {cellWidth: 35, halign: 'left'},
        4: {cellWidth: 35, halign: 'left'},
        5: {cellWidth: 55, halign: 'left'},
        6: {cellWidth: 35},
        7: {cellWidth: 35},
        8: {cellWidth: 30},
        9: {cellWidth: 30},
      }

      let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
      let site_text = '';
      let sites = this.selectedSite
      for (var s = 0; s < sites.length; s++) {
        if(s == 0){
            site_text += this.sites.find(x => x.id === sites[s]).name
        } else {
            site_text += ', ' + this.sites.find(x => x.id === sites[s]).name
        }
      }

      // Get all unique document_no
      let documentNos = reports.map(item => item.document_no).filter((value, index, self) => self.indexOf(value) === index);

      // Loop document_no
      documentNos.map((documentNo, indx) => {
        let reportData = [];
        let xPosition = 15;
        let yPosition = 35;
        let postedAt = '';

        // Filter by document_no from the requested data
        const reportsPerDocumentNo = reports.filter(report => report.document_no == documentNo);

        // Loop Report per document_no
        reportsPerDocumentNo.map(report => {
          postedAt = `${moment(report.posted_at).format('MMMM DD YYYY h:mm:ss a')}`;

          // Compute for Variance difference
          let variance = this.computeVariance(report.quantity, report.actual_quantity);

          // Assemble Report Data
          let detail = [
            report.line_no || "",
            report.product_id || "",
            report.stock_no || "",
            report.barcode || "",
            report.reference_code || "",
            report.description || "",
            report.quantity || "",
            report.actual_quantity || "",
            variance || "",
          ];

          // Push to report data array for assembling
          reportData.push(detail);
        })

        let reportLogo = document.getElementById('reportLogo');
        // Set BXI Logo
        doc.addImage(reportLogo, "PNG", 15, 8, 20, 20);

        // Set Site Name text
        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text(340,20,site_text,"right");

        // Set Document No. and Posted At labels
        doc.setFontSize(11);
        doc.setFontType("bold");
        doc.text(xPosition, yPosition, "Document No:");
        doc.text(xPosition, yPosition + 8, "Posted At:");

        // Set Document No. and Posted At values
        doc.setFontType("normal");
        doc.text(xPosition + 30, yPosition, `${documentNo}`);
        doc.text(xPosition + 23, yPosition + 8, postedAt);

        // Assemble table
        doc.autoTable({
          startX: xPosition,
          startY: 50,
          head: headers,
          body: reportData,
          theme: 'plain',
          tableWidth: 'wrap',
          headStyles: { lineWidth: 0.15, cellPadding: 2 },
          styles: { cellPadding: 1.0, fontSize: 9, halign: 'right' },
          columnStyles: columnStyles
        });

        // Set up footer per page
        doc.setFontSize(10);
        doc.text(15,200,"Printed By: " + printedBy)
        doc.text(340,200,"Physical Count - Variance Report", "right")
        doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
        doc.text(340,205,"Page " + (indx + 1)  + " of " + documentNos.length, "right")

        if (documentNo != documentNos[documentNos.length - 1]) {
          // Add page when current document no is not equal to the last document no
          doc.addPage();
        }
      })

      // Save and export PDF
      //doc.save(`${documentName}-${moment().format('YYYYMMDDHHmmss')}.pdf`);
      window.open(URL.createObjectURL(doc.output("blob")))
    },
    generateFile: async function() {
      this.exportJsonData = [];

      // Change File Name of CSV and Excel
      this.exportFileName = `${documentName}-${moment().format('YYYYMMDDHHmmss')}`

      // Request for data
      const reports = await this.getData();
      if (reports.length == 0) { return; }

      this.exportJsonData = reports;
    },
    exportCSV() {
      // Assemble CSV data
      let jsonData = [];

      this.exportJsonData.map(report => {
        let postedAt = `${moment(report.posted_at).format('MMMM DD YYYY h:mm:ss a')}`;
        let variance = this.computeVariance(report.quantity, report.actual_quantity);

        jsonData.push({
          documentNo: report.document_no || "",
          postedAt: postedAt,
          lineNo: report.line_no || "",
          productCode: `${report.product_id || ""}`,
          stockNo: report.stock_no || "",
          barcode: `${report.barcode}` || "",
          refCode: report.reference_code || "",
          description: report.description || "",
          actualQuantity: report.quantity || "",
          onHandQuantity: report.actual_quantity || "",
          variance: variance || "",
        })
      })

      return jsonData

    },
    exportExcel() {
      // Assemble Excel data
      let jsonData = [];

      this.exportJsonData.map(report => {
        let postedAt = `${moment(report.posted_at).format('MMMM DD YYYY h:mm:ss a')}`;
        let variance = this.computeVariance(report.quantity, report.actual_quantity);

        jsonData.push({
          documentNo: report.document_no || "",
          postedAt: postedAt,
          lineNo: report.line_no || "",
          productCode: `${report.product_id || ""}`,
          stockNo: report.stock_no || "",
          barcode: `${report.barcode}` || "",
          refCode: report.reference_code || "",
          description: report.description || "",
          actualQuantity: report.quantity || "",
          onHandQuantity: report.actual_quantity || "",
          variance: variance || "",
        })
      })

      // Clear requested JSON Data
      this.clearExportJsonData();

      return jsonData;
    }
  }
}
</script>

